import { render, staticRenderFns } from "./CreateAppButton.vue?vue&type=template&id=04e8ceab"
import script from "./CreateAppButton.vue?vue&type=script&lang=js"
export * from "./CreateAppButton.vue?vue&type=script&lang=js"
import style0 from "./CreateAppButton.vue?vue&type=style&index=0&id=04e8ceab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports